import { combineReducers } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'

import language from './languageSlice'
import auth from './authSlice'
import user from './userSlice'
import address from './addressSlice'

const history = createBrowserHistory()
const reducers = {
  language,
  auth,
  user,
  address,
}

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
